"use client";

import Section from "@/components/static/Section";
import Headline from "@/components/static/Headline";
import Text from "@/components/static/Text";
import Image from "next/image";
import parse from "html-react-parser";
import { cn } from "@/lib/utils";
import { SectionPadding, HeadlineProps, ImageProps, ButtonProps } from "@/lib/types";

type Content = {
    headline: HeadlineProps;
    intro: string;
    image: ImageProps;
    settings: {
        padding: SectionPadding;
        backgroundColor: string;
    };
    buttons: ButtonProps[];
    items: SlideProps[];
};

type SlideProps = {
    headline: string;
    text: string;
    image: ImageProps;
};

export default function Layout_60({ content }: { content: Content }) {
    return (
        <Section dataComponent='Layout_60' settings={content?.settings}>
            <div className='container'>
                <div className='flex flex-col lg:flex-row gap-20 md:gap-x-12 lg:gap-x-20'>
                    <div className='max-w-[420px] w-full'>
                        <Headline tag={content.headline.tag} topline={content.headline.topline}>
                            {content.headline.title}
                        </Headline>
                    </div>
                    <div>
                        {content.intro && (
                            <div className='mb-6 md:mb-8 md:text-md'>
                                {parse(content.intro ?? "")}
                            </div>
                        )}
                        <div className='grid grid-cols-1 gap-y-20 gap-x-6 py-2 sm:grid-cols-2'>
                            {content?.items?.map((item, index) => (
                                <div key={index}>
                                    <div className='mb-3 md:mb-4'>
                                        <Image
                                            src={item.image.url}
                                            className='size-12'
                                            alt={item.image.alt}
                                            height={item.image.height}
                                            width={item.image.width}
                                        />
                                    </div>
                                    <h6 className='mb-3 text-lg  md:mb-4'>{item.headline}</h6>
                                    <div className='text-textSecondary'>
                                        {parse(item.text ?? "")}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    );
}
